import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { DatosOrganizativos } from '../models/datos-organizativos';
import { environment } from '../../environments/environment';
import { switchMap, map } from 'rxjs/operators';
import { PersonalCurrentFilter } from '../models/personalCurrentFIlter';

const baseUrl = environment.hostService + '/DatosOrganizativos';

@Injectable({
  providedIn: 'root'
})
export class DatosOrganizativosService {
   
  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/Index' })
  }

  getByPersonalId(personalId: number): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/GetByPersonalId/' + personalId })
  }

  getByPersonalCurrent(filter: PersonalCurrentFilter ): Observable<any>
  {
    return this._http.post<any>({ url: baseUrl + '/GetByPersonalCurrent',body: filter })
  }

  getList(): Observable<any>
  {
    return this._http.get<any>({ url: baseUrl + '/List' })
  }

  delete(id: number)
  {
    return this._http.get({ url: baseUrl + '/Delete?id=' + id});
  }

  save(data, cortarRegistro): Observable<any>
  {
    return this._http.post<any>({ url: baseUrl + '/Save/' + cortarRegistro, body: data, cacheMins: 0 });
  }
}
